'use strict';

const DesignRepository = require('./../repository/DesignRepository');
const Container = require('./../../../core/container');

module.exports.beforeConfig = (config) => {
  DesignRepository.getFonts().done((fonts) => {
    config['font_names'] = fonts.map((font) => `${font.label}/${font.value}`).join(';');
  });
  config['language'] = Container.get('language');
  config['contentsLangDirection'] = 'ar' === Container.get('language') ? 'rtl' : 'ltr';
};
